import {
  GET_CUSTOMER_CONTACTS_PENDING,
  GET_CUSTOMER_CONTACTS_FAILED,
  GET_CUSTOMER_CONTACTS_FULFILLED,
  SET_CUSTOMER_CONTACTS_FAILED,
  SET_CUSTOMER_CONTACTS_PENDING,
  SET_CUSTOMER_CONTACTS_FULFILLED,
  SET_CUSTOMER_INFO_EDITABLE_STATE,
  SET_EDIT_CONTACT_TYPE,
  RESET_CUSTOMER_CONTACTS,
  SET_SITE_CONTACT,
} from "constants-lib/actionTypes"

const initialState = {
  fetchState: ``,
  putState: ``,
  verificationTokenPref: ``,
  isContactInfoEditable: false,
  editContactType: ``,
  siteContactName: ``,
  siteContactEmail: ``,
  siteContactPhone: ``,
  roFormDate: ``,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_CUSTOMER_CONTACTS_PENDING:
      return {
        ...state,
        fetchState: `pending`,
        putState: state.putState,
        verificationTokenPref: ``,
      }

    case GET_CUSTOMER_CONTACTS_FAILED:
      return {
        ...state,
        fetchState: `failed`,
        putState: state.putState,
        verificationTokenPref: ``,
        ...action.payload,
      }

    case GET_CUSTOMER_CONTACTS_FULFILLED:
      return {
        ...state,
        fetchState: `fulfilled`,
        putState: state.putState,
        verificationTokenPref: action.payload.verificationTokenPref,
        data: {
          ...action.payload,
        },
      }

    case SET_CUSTOMER_CONTACTS_FAILED:
      return {
        ...state,
        putState: `failed`,
        ...action.payload,
      }

    case SET_CUSTOMER_CONTACTS_PENDING:
      return {
        ...state,
        putState: `pending`,
      }

    case SET_CUSTOMER_CONTACTS_FULFILLED:
      return {
        ...state,
        putState: `fulfilled`,
        isContactInfoEditable: true,
        data: {
          ...state.data,
          customerContacts: {
            ...state.data.customerContacts,
            contacts: action.payload,
          },
        },
      }

    case SET_CUSTOMER_INFO_EDITABLE_STATE:
      return {
        ...state,
        isContactInfoEditable: action.payload,
      }

    case SET_EDIT_CONTACT_TYPE:
      return {
        ...state,
        editContactType: action.payload,
      }

    case RESET_CUSTOMER_CONTACTS:
      return initialState

    case SET_SITE_CONTACT:
      return {
        ...state,
        [action.payload.property]: action.payload.value,
      }

    default:
      return state
  }
}
